import { css, Interpolation, Theme } from '@emotion/react'

export const wrapper: Interpolation<Theme> = (theme) => css`
  height: 100vh;
  width: 100%;
  display: flex;
  background: ${theme.backgrounds.backgroundFour};
  font-family: ${theme.fonts.family.PlusJakartaSans};
`

export const content: Interpolation<Theme> = (theme) => css`
  height: 100%;
  flex: 1;
  background: ${theme.backgrounds.backgroundFour};
  overflow-y: scroll;
`
